<template>
  <div>
    <div class="container">
      <b-container fluid id="add-school">
        <h1 class="title">Add Primary School</h1>
        <div id="alerts">
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            >You have successfully added a primary school!</b-alert
          >
          <b-alert
            :show="showError"
            dismissible
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            variant="danger"
            >Something went wrong. Please ensure the school name, and location
            are entered.</b-alert
          >
        </div>
        <b-row class="mt-4">
          <b-col>
            <h4 class="sub-title">Basic Information</h4>
            <div class="name mt-4">
              <label for="name">Name:</label>
              <b-form-input
                name="name"
                type="text"
                id="school-name"
                v-model="schoolName"
                required
                :state="nameInput()"
              ></b-form-input>
            </div>
            <div id="type" class="dropdown mt-4">
              <label for="type">Registered With Government:</label>
              <br />
              <b-form-select v-model="regWithGov" name="type">
                <option disabled value>Select...</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </b-form-select>
            </div>
          </b-col>
          <b-col>
            <geo-info
              singular="school"
              plural="primarySchools"
              :coords="true"
              parent="primary-school"
            ></geo-info>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <br />
    <div class="container">
      <b-container fluid>
        <br />
        <confirm-submit></confirm-submit>
        <b-button
          :size="'lg'"
          :variant="'primary'"
          class="app_school_btn mb-4"
          :disabled="isDisabled"
          @click.prevent="createPrimarySchool"
          >Add Primary School</b-button
        >
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import GeoInfo from "@/components/GeoInfo";
import ConfirmSubmit from "@/components/ConfirmSubmit";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";

export default {
  name: "NewPrimarySchool",
  mixins: [flash, scrollTo],
  components: {
    GeoInfo,
    ConfirmSubmit,
  },
  data() {
    return {
      showError: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      isDisabled: false,
      allTeachers: [],
    };
  },
  methods: {
    ...mapActions({
      CREATE_SCHOOL: "primarySchools/CREATE_SCHOOL",
      RESET_SCHOOLS_STATE: "primarySchools/RESET_SCHOOLS_STATE",
    }),
    async createPrimarySchool() {
      if (!this.$store.state.confirmed) {
        alert("Please confirm the information above is correct");
        return;
      }
      if (!this.formError) {
        window.scrollTo(0, 0);
        this.flashError();
        return;
      }
      this.isDisabled = await true;
      await this.CREATE_SCHOOL();
      this.scrollTo(0, 0);
      await this.flashSuccess();
      await this.RESET_SCHOOLS_STATE();
      await this.$store.commit("resetConfirmed");
      this.isDisabled = await false;
      setTimeout(() => this.$router.push({ name: "PrimarySchoolsList" }), 1500);
    },
    nameInput() {
      return this.$store.state.primarySchools.school.school_name.length > 2;
    },
  },
  computed: {
    schoolName: {
      get() {
        return this.$store.state.primarySchools.school.school_name;
      },
      set(val) {
        this.$store.commit("primarySchools/school_name", val);
      },
    },
    regWithGov: {
      get() {
        return this.$store.state.primarySchools.school.registered_with_gov;
      },
      set(val) {
        this.$store.commit("primarySchools/registered_with_gov", val);
      },
    },
    formError() {
      if (this.schoolName.length <= 1 || this.schoolName == null) {
        return false;
      }
      if (
        this.$store.state.primarySchools.school.country.length <= 1 ||
        this.$store.state.primarySchools.school.country == null
      ) {
        return false;
      }
      if (
        this.$store.state.primarySchools.school.region.length <= 1 ||
        this.$store.state.primarySchools.school.region == null
      ) {
        return false;
      }
      if (
        this.$store.state.primarySchools.school.district.length <= 1 ||
        this.$store.state.primarySchools.school.district == null
      ) {
        return false;
      }
      return true;
    },
  },
  async created() {
    this.RESET_SCHOOLS_STATE();
  },
};
</script>

<style scoped>
.container {
  width: 90%;
  align-content: center;
}
.form div {
  margin: 20px;
}
.app_school_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}
</style>
